module.exports = __webpack_public_path__ + "static/media/ro.b091db3b.svg";